import {put,call} from 'redux-saga/effects';
import MulesoftDataService from '../../services/mulesoftData.services';
import { constants } from '../../constants';

import { setTransactionHistorySuccess,
         setTransactionHistoryError,
         toggleAlertShowStatus } from '../actions';

export default function * getTranscriptHistory(args){
    try {
      const res = yield call([MulesoftDataService, 'getTranscriptHistory'], args.payload.tReq);
      yield put(setTransactionHistorySuccess(res.data));
    } catch (error) {
     yield put(toggleAlertShowStatus({
        showAlert: true,
        alertVarient:'danger',
        alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
        }));    
        yield put(setTransactionHistoryError()) 
    }
}